import type { ReactNode } from "react";
import { Pressable, type StyleProp, type ViewStyle } from "react-native";
import { Link, type Href } from "expo-router";

interface NavPressableProps {
  children: ReactNode;
  href?: Href;
  externalHref?: string;
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
  accessibilityLabel?: string;
}

export function NavPressable({ children, href, externalHref, onPress, style, accessibilityLabel }: NavPressableProps) {
  if (externalHref) {
    return (
      <a href={externalHref} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
        <Pressable onPress={onPress} accessibilityRole="link" accessibilityLabel={accessibilityLabel} style={style}>
          {children}
        </Pressable>
      </a>
    );
  }

  if (href) {
    return (
      <Link href={href} asChild>
        <Pressable onPress={onPress} accessibilityRole="link" accessibilityLabel={accessibilityLabel} style={style}>
          {children}
        </Pressable>
      </Link>
    );
  }

  return (
    <Pressable onPress={onPress} style={style} accessibilityLabel={accessibilityLabel}>
      {children}
    </Pressable>
  );
}
